module.exports = __webpack_public_path__ + "static/img/28武汉中博.fe58f2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/28武汉中博.jpg
// module id = XCOG
// module chunks = 1